/* Desktop : un clic sur un lien mailto copie l'adresse au lieu d'ouvrir un client mail
   (souvent absent sur desktop, d'où des rage clicks). Tactile : mailto natif. */
(function () {
  if (window.ovMailtoBound) return;
  window.ovMailtoBound = true;

  var desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  var toast, timer;

  function ensureToast() {
    if (toast) return toast;
    var style = document.createElement('style');
    style.textContent =
      '.ov-mail-toast{position:fixed;left:50%;bottom:24px;z-index:10010;max-width:calc(100vw - 32px);padding:12px 20px;' +
      'border-radius:999px;background:var(--ov-night);color:var(--ov-cream);font-size:14px;line-height:1.4;' +
      'box-shadow:var(--ov-shadow-card);transform:translate(-50%,12px);opacity:0;pointer-events:none;' +
      'transition:opacity .2s ease,transform .2s ease}' +
      '.ov-mail-toast.is-visible{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
      '.ov-mail-toast b{font-weight:700;user-select:all;-webkit-user-select:all}' +
      '@media (prefers-reduced-motion: reduce){.ov-mail-toast{transition:none;transform:translate(-50%,0)}}';
    document.head.appendChild(style);
    toast = document.createElement('div');
    toast.className = 'ov-mail-toast ov-font-heading';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    return toast;
  }

  function show(prefix, email, duration) {
    var el = ensureToast();
    el.textContent = prefix;
    var b = document.createElement('b');
    b.textContent = email;
    el.appendChild(b);
    el.classList.add('is-visible');
    clearTimeout(timer);
    timer = setTimeout(function () { el.classList.remove('is-visible'); }, duration);
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!desktop.matches) return;
    var link = e.target.closest && e.target.closest('a[href^="mailto:" i]');
    if (!link) return;

    var email = link.getAttribute('href').replace(/^mailto:/i, '').split('?')[0];
    try { email = decodeURIComponent(email); } catch (err) {}
    email = email.trim();
    if (!email) return;

    e.preventDefault();

    var domain = email.split('@')[1] || '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'contact_email_copy',
      email_domain: domain.toLowerCase(),
      link_text: (link.textContent || '').replace(/\s+/g, ' ').trim()
    });

    copy(email).then(function (ok) {
      if (ok) show('Adresse copiée : ', email, 2500);
      else show('Écrivez-nous à ', email, 6000);
    });
  });
})();
